import { render, staticRenderFns } from "./syncProjection.vue?vue&type=template&id=6561f174&scoped=true&"
import script from "./syncProjection.vue?vue&type=script&lang=js&"
export * from "./syncProjection.vue?vue&type=script&lang=js&"
import style0 from "./syncProjection.vue?vue&type=style&index=0&id=6561f174&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561f174",
  null
  
)

export default component.exports